import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=5bb998de&scoped=true"
import script from "./exam.vue?vue&type=script&lang=js"
export * from "./exam.vue?vue&type=script&lang=js"
import style0 from "./exam.vue?vue&type=style&index=0&id=5bb998de&prod&lang=scss&scoped=true"
import style1 from "./exam.vue?vue&type=style&index=1&id=5bb998de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb998de",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/product/exam.vue
// module id = null
// module chunks = 